import React from 'react';

export const SvgCheckMark = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M11.6162 0.5C17.7459 0.5 22.7324 5.57599 22.7324 11.8594C22.7324 18.1427 17.7458 23.2188 11.6162 23.2188C5.48662 23.2187 0.500038 18.1427 0.5 11.8594C0.5 5.57602 5.4866 0.500036 11.6162 0.5Z"
      stroke="#061622"
    />
    <path
      d="M7.74374 12.0338L10.5317 14.8242L16.456 8.89453"
      stroke="#061622"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
